import { Typography, Chip, Skeleton, Link } from '@mui/material'
import { FlexCol } from '../../../components/Flex'
import { CustomListItem } from '../../../components'
import { numberFormat } from '../../../utils'

interface NftCreditItemProps {
  yyyymmdd?: number
  os?: string
  plan?: string
  credits?: number
  previousCredits?: number
  nftId?: string
  loading?: boolean
}

const formatDate = (yyyymmdd?: number): string => {
  if (!yyyymmdd) return 'Unknown Date'
  const str = yyyymmdd.toString()
  const year = str.substring(0, 4)
  const month = str.substring(4, 6)
  const day = str.substring(6, 8)
  return `${month}/${day}/${year}`
}

const NftCreditItem: React.FC<React.PropsWithChildren<NftCreditItemProps>> = ({
  yyyymmdd,
  os,
  plan,
  credits,
  previousCredits,
  nftId,
  loading,
}) => {
  const isPositive = credits && credits > 0
  const currentTotal = previousCredits !== undefined && credits !== undefined ? previousCredits + credits : undefined

  if (loading) {
    return (
      <CustomListItem>
        <FlexCol alignItems="flex-start" style={{ flex: 1 }}>
          <Skeleton variant="rectangular" width={140} height={24} sx={{ borderRadius: '16px', marginBottom: 0.5 }} />
          <Skeleton variant="text" width={100} height={24} />
        </FlexCol>
        <FlexCol alignItems="flex-end">
          <Skeleton variant="text" width={100} height={32} />
          <Skeleton variant="text" width={40} height={20} />
        </FlexCol>
      </CustomListItem>
    )
  }

  return (
    <CustomListItem>
      <FlexCol alignItems="flex-start" style={{ flex: 1 }}>
        <Chip 
          label="NFT Credit Update" 
          color="success" 
          size="small"
          sx={{ fontWeight: 600, marginBottom: 0.5 }}
        />
        {nftId && (
          <Typography variant="body2" sx={{ mt: 0.5 }}>
            NFT: <Link href={`https://nfts.coinapp.co/upgrades/geodrop/${nftId}`} target="_blank" rel="noopener">{nftId}</Link>
          </Typography>
        )}
        {plan && <Typography variant="body2" color="textSecondary">Plan: {plan}</Typography>}
        {os && <Typography variant="body2" color="textSecondary">OS: {os}</Typography>}
        <Typography variant="body2" color="textSecondary">
          {formatDate(yyyymmdd)}
        </Typography>
      </FlexCol>
      <FlexCol alignItems="flex-end">
        <Typography variant="h6" fontWeight="bold" color={isPositive ? 'success.main' : 'error.main'}>
          {isPositive ? '+' : ''}{numberFormat(credits || 0)}
        </Typography>
        {previousCredits !== undefined && (
          <Typography variant="caption" color="textSecondary">
            Prev: {numberFormat(previousCredits)}
          </Typography>
        )}
        {currentTotal !== undefined && (
          <Typography variant="caption" color="textSecondary">
            Total: {numberFormat(currentTotal)}
          </Typography>
        )}
      </FlexCol>
    </CustomListItem>
  )
}

export default NftCreditItem